<app-card-auth title="Sign Up">
  <app-create-account-form
    [redirectLink]="defaultLink"
    [buttonLink]="buttonLink"
  ></app-create-account-form>
</app-card-auth>
